<div #parentElement [ngClass]="showGridColumns()"
     class="{{userRoleCssClass()}}">
    <app-tile *ngIf="isAdmin"
              [customDesignTiles]="moreThan3Tiles"
              [tabindex]="4"
              [icon]="'person'"
              [title]="'GENERAL.USER_MANAGEMENT' | translate"
              [text]="'ONBOARDING.WELCOME.USER_MANAGEMENT_TEXT' | translate"
              [ariaLabel]="('GENERAL.USER_MANAGEMENT' | translate) + ('GENERAL.BUTTON' | translate)"
              (tileClickEvent)="nextStepEvent.emit(userManagementEnum)">
    </app-tile>
    <app-tile *ngIf="isAdmin || isSuperAdmin"
              [customDesignTiles]="moreThan3Tiles"
              [tabindex]="4"
              [customIcon]="'file-excel'"
              [title]="'GENERAL.EXPORT_DATA' | translate"
              [text]="'GENERAL.EXPORT_DATA_DESCRIPTION' | translate"
              [ariaLabel]="('GENERAL.EXPORT_DATA' | translate) + ('GENERAL.BUTTON' | translate)"
              (tileClickEvent)="nextStepEvent.emit(exportDataEnum)">
    </app-tile>
    <app-tile *ngIf="isPatient"
              [customDesignTiles]="moreThan3Tiles"
              [cdkTrapFocus]="disableResume && isAudioMode"
              [cdkTrapFocusAutoCapture]="disableResume && isAudioMode"
              [tabindex]="2"
              [disabled]="!disableResume"
              [customIcon]="'play'"
              [title]="'ONBOARDING.WELCOME.START_NEW' | translate"
              [text]="'ONBOARDING.WELCOME.START_NEW_TEXT' | translate"
              [ariaLabel]="('ONBOARDING.WELCOME.START_NEW' | translate) + ('GENERAL.BUTTON' | translate)"
              (tileClickEvent)=nextStepEvent.emit(startNewConsentEnum)>
    </app-tile>
    <app-tile *ngIf="isPatient"
              [customDesignTiles]="moreThan3Tiles"
              [cdkTrapFocus]="!disableResume && isAudioMode"
              [cdkTrapFocusAutoCapture]="!disableResume && isAudioMode"
              [tabindex]="disableResume ? -1 : 1"
              [disabled]="disableResume"
              [icon]="'replay'"
              [title]="'ONBOARDING.WELCOME.RESUME' | translate"
              [text]="'ONBOARDING.WELCOME.RESUME_TEXT' | translate"
              [ariaLabel]="('ONBOARDING.WELCOME.RESUME' | translate) + ('GENERAL.BUTTON' | translate)"
              (tileClickEvent)="nextStepEvent.emit(resumeConsentEnum)">
    </app-tile>
    <app-tile *ngIf="isDoctor || isPatient"
              [customDesignTiles]="moreThan3Tiles"
              [tabindex]="!hasConsumedConsents ? -1 : 3"
              [icon]="'reorder'"
              [disabled]="isPatient && !hasConsumedConsents"
              [title]="(isDoctor ? 'ONBOARDING.WELCOME.VIEW_DOCTOR' : 'ONBOARDING.WELCOME.VIEW_PATIENT') | translate"
              [text]="(isDoctor ? 'ONBOARDING.WELCOME.VIEW_DOCTOR_TEXT' : 'ONBOARDING.WELCOME.VIEW_PATIENT_TEXT') | translate"
              [ariaLabel]="((isDoctor ? 'ONBOARDING.WELCOME.VIEW_DOCTOR' : 'ONBOARDING.WELCOME.VIEW_PATIENT') | translate) + ('GENERAL.BUTTON' | translate)"
              (tileClickEvent)="nextStepEvent.emit(viewSubmittedConsentEnum)">
    </app-tile>
    <app-tile *ngIf="isEditor"
              [customDesignTiles]="moreThan3Tiles"
              [tabindex]="3"
              [icon]="'note_add'"
              [disabled]="false"
              [title]="'CMS.EDUCATION.TILE_TITLE' | translate"
              [text]="'CMS.EDUCATION.TILE_DESCRIPTION' | translate"
              [ariaLabel]="('CMS.EDUCATION.TILE_TITLE' | translate) + ('GENERAL.BUTTON' | translate)"
              (tileClickEvent)="nextStepEvent.emit(cmsIndicationsEnum)">
    </app-tile>
    <app-tile *ngIf="isEditor"
              [customDesignTiles]="moreThan3Tiles"
              [tabindex]="4"
              [icon]="'image'"
              [disabled]="false"
              [title]="'CMS.MEDIA.TILE_TITLE' | translate"
              [ariaLabel]="('CMS.MEDIA.TILE_TITLE' | translate) + ('GENERAL.BUTTON' | translate)"
              [text]="'CMS.MEDIA.TILE_DESCRIPTION' | translate"
              (tileClickEvent)="nextStepEvent.emit(cmsImagesEnum)">
    </app-tile>
    <app-tile *ngIf="isAdmin"
              [customDesignTiles]="moreThan3Tiles"
              [tabindex]="4"
              [customIcon]="'health_data_security'"
              [title]="'GENERAL.MEDICATION_MANAGEMENT' | translate"
              [text]="'ONBOARDING.WELCOME.MEDICATION_TEXT' | translate"
              [ariaLabel]="('GENERAL.MEDICATION_MANAGEMENT' | translate) + ('GENERAL.BUTTON' | translate)"
              (tileClickEvent)=nextStepEvent.emit(medicationEnum)>
    </app-tile>
    <app-tile *ngIf="isPatient || isDoctor || isEditor || isAdmin"
              [customDesignTiles]="moreThan3Tiles"
              [tabindex]="4"
              [icon]="'build'"
              [title]="'GENERAL.SETTINGS' | translate"
              [text]="'ONBOARDING.WELCOME.SETTINGS_TEXT' | translate"
              [ariaLabel]="('GENERAL.SETTINGS' | translate) + ('GENERAL.BUTTON' | translate)"
              (tileClickEvent)=nextStepEvent.emit(settingsEnum)>
    </app-tile>
    <app-tile *ngIf="isSuperAdmin"
              [customDesignTiles]="moreThan3Tiles"
              [tabindex]="2"
              [icon]="'groups'"
              [title]="'GENERAL.ORGANIZATION_MANAGEMENT' | translate"
              [text]="'ONBOARDING.WELCOME.ORGANIZATION_MANAGEMENT_TEXT' | translate"
              [ariaLabel]="('GENERAL.ORGANIZATION_MANAGEMENT' | translate) + ('GENERAL.BUTTON' | translate)"
              (tileClickEvent)=nextStepEvent.emit(orgManagement)>
    </app-tile>
</div>
